// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/chunk-" + {"5":"1710b","412":"1e43a"}[chunkId] + ".js";
};